import { ROLE_PERMISSIONS } from 'shared/constants';

export const hasValue = (value) => {
  return value !== null && value !== undefined && value !== '';
};

export const isImageFile = (file) => {
  const fileName = file.name;
  const fileExtension = fileName.split('.').pop().toLowerCase();
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
  return imageExtensions.includes(fileExtension);
};

export const getTitle = (gender) => {
  if (gender) {
    if (gender.toLowerCase() === 'male') {
      return 'Mr.';
    } else if (gender.toLowerCase() === 'female') {
      return 'Ms.';
    } else {
      return '';
    }
  }
  return '';
};

export const isAnotherSystemRunning = (currentRunning, anotherSystem) => {
  if (currentRunning === null) {
    return false;
  }
  if (currentRunning === anotherSystem) {
    return true;
  }
  return false;
};

export const extractUniquePropertyValues = (arr, prop) => {
  const uniqueValues = new Set();

  arr.forEach((item) => {
    if (item.hasOwnProperty(prop)) {
      uniqueValues.add(item[prop]);
    }
  });
  return Array.from(uniqueValues);
};

const extractAllowedSettings = (role) => {
  return Object.keys(ROLE_PERMISSIONS.ALLOWED_SETTINGS).filter((setting) =>
    ROLE_PERMISSIONS.ALLOWED_SETTINGS[setting].includes(role)
  );
};

export const checkUserPermissions = (role) => {
  const permissions = {};
  for (const [key, value] of Object.entries(ROLE_PERMISSIONS)) {
    if (key === 'ALLOWED_SETTINGS') {
      permissions[key] = extractAllowedSettings(role);
    } else {
      permissions[key] = value.includes(role);
    }
  }
  return permissions;
};

const getDeviceName = (device) =>
  device?.machineName || device?.deviceName || device?.device_name || '';

export const filteredSuggestionsHandler = (list, locations, inputValue) => {
  if (!list || !locations.all || !inputValue) {
    return [];
  }

  return list.filter((suggestion) => {
    const parts = suggestion.split(' - ');
    const locationId = parts[0];
    const locationData = locations.all[locationId];

    const searchableNames = parts.map((part, index) => {
      if (index === 0) {
        return locationData?.locationName || '';
      }

      if (parts.length > 2 && index === 1) {
        const specificLocation =
          locationData?.subLocations?.[part] ||
          locationData?.specific_location?.find((spec) => spec.zone_id === part);

        return (
          specificLocation?.specificLocationName ||
          specificLocation?.locationName ||
          specificLocation?.zone_name ||
          ''
        );
      }

      const machineId = parts.length > 2 ? parts[2] : part;
      const specificLocationId = parts.length > 2 ? parts[1] : null;
      const directDevice =
        locationData?.devices?.[machineId] || locationData?.machines?.[machineId];
      const specificLocation =
        specificLocationId &&
        (locationData?.subLocations?.[specificLocationId] ||
          locationData?.specific_location?.find(
            (spec) => spec.zone_id === specificLocationId
          ));
      const specificDevice =
        specificLocation?.devices?.[machineId] ||
        specificLocation?.devices?.find?.(
          (device) =>
            device.device_id === machineId ||
            device.device_mac === machineId ||
            device.deviceMac === machineId
        );

      return getDeviceName(directDevice || specificDevice);
    });

    const searchableString = searchableNames
      .flat()
      .filter(Boolean)
      .join(' - ')
      .toUpperCase();
    return searchableString.includes(inputValue.toUpperCase());
  });
};
